import { render } from "./ShowMotm.vue?vue&type=template&id=1507ecae&scoped=true"
import script from "./ShowMotm.vue?vue&type=script&lang=js"
export * from "./ShowMotm.vue?vue&type=script&lang=js"

import "./ShowMotm.vue?vue&type=style&index=0&id=1507ecae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1507ecae"]])

export default __exports__